module.exports = __webpack_public_path__ + "static/media/store-weis.5db40310.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/whereToBuy/stores/store-weis.jpg
// module id = 233
// module chunks = 0